import PropTypes from 'prop-types'

import theme from 'theme'
import Button from 'components/common/Button'
import Image from 'components/common/Image'

export default function SSOButton({ onClick, logo, alt, text, ...rest }) {
  return (
    <Button
      secondary
      stretch
      css={{ marginBottom: theme.space[3] }}
      label={text}
      type="button"
      onClick={onClick}
      {...rest}
    >
      <span
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Image
          alt={alt}
          css={{ marginRight: theme.space[2], height: theme.space[4] }}
          src={logo}
        />
        {text}
      </span>
    </Button>
  )
}

SSOButton.propTypes = {
  alt: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  logo: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
}
